import { render, staticRenderFns } from "./PaginationControls.vue?vue&type=template&id=2135d434&scoped=true"
import script from "./PaginationControls.vue?vue&type=script&lang=ts"
export * from "./PaginationControls.vue?vue&type=script&lang=ts"
import style0 from "./PaginationControls.vue?vue&type=style&index=0&id=2135d434&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2135d434",
  null
  
)

export default component.exports